import { Logout, Settings } from '@mui/icons-material';
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import _ from 'lodash';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import useUser from '../../../../hooks/useUser';
import { logout } from '../../../../keycloak';
import { classnames } from '../../../../utils';
import styles from './UserAccountMenu.module.scss';
import { useTenantSelection } from '../../../../features/TenantSelection/contexts/TenantSelection';
import CachedIcon from "@mui/icons-material/Cached";

interface UserAccountMenuProps {
  open: boolean;
  onClose: () => void;
  anchorEl: null | HTMLElement;
}

const UserAccountMenu: FC<UserAccountMenuProps> = ({
  anchorEl,
  open,
  onClose,
}) => {
  const { currentUser: user } = useUser();
  const tenantSelection = useTenantSelection();
  const t = useTranslations('userMenu');
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClick={onClose}
      onClose={onClose}
      id={styles.userAccountMenu}
      slotProps={{
        paper: {
          sx: { minWidth: 220, px: 1 },
        },
      }}
    >
      <Box className={styles.userInfo} component='li'>
        <Typography fontWeight={500}>
          {_.capitalize(user?.tenant.displayName)}
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          {user?.email}
        </Typography>
      </Box>
      <Divider />
      <MenuItem component={Link} to='/settings/preferences' className={styles.menuItem}>
        <ListItemIcon>
          <Settings fontSize='small' />
        </ListItemIcon>
        <ListItemText primary={t('settings')} />
      </MenuItem>
      {user?._isInternalUser &&
        <MenuItem
          className={styles.menuItem}
          onClick={() => tenantSelection.open()}
        >
          <ListItemIcon>
            <CachedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={t('switchTenant')} />
        </MenuItem>
      }
      <Divider />
      <MenuItem
        className={classnames(styles.menuItem, styles.logoutMenu)}
        onClick={logout}
      >
        <ListItemIcon>
          <Logout fontSize='small' color='error' />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            color: 'error',
          }}
          color='error'
          primary={t('logout')}
        />
      </MenuItem>
    </Menu>
  );
};

export default UserAccountMenu;
